import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import IndexList from '../../../lib/ui/IndexControl'

export default class SelectPerson {
  constructor (element, args) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Kies persoon',
      leftHandButtons: [{
        onclick: args.oncancel,
        icon: '\ue00d'
      },
        {
          onclick: args.onok,
          icon: '\ue03d',
          label: 'Geen selectie'
        }]
    })

    window.PRIM.dataAccess.resolve('people', null, true).then((items) => {
      this.results.setItems(items)
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    this.results = new IndexList(div, {items: [], onclick: args.onok})
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/person/action/SelectPerson.js